<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Protocol Change Request
  <div class="pull-right">
    <a class="boxclose" (click)="closeDialog()"></a>
  </div>
</h2>
<mat-dialog-content>
  <div class="row">
    <div class="col-md-12">
      <mat-form-field class="p-2">
        <textarea matInput placeholder="Enter Change Request" [(ngModel)]="requestBody" class="col-md-12"
          required></textarea>
      </mat-form-field>
      <div class="alert custom-alert-danger p-2" role="alert" *ngIf="requestError">
        <span class="sr-only">Error:</span>
        Please enter change request
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="btn btn-success btn-semi-round btn-demo bgBlue pull-right mr-2" (click)="sendChangeRequest()">
    Send Request
  </button>
  <button (click)="closeDialog()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right">
    Close
  </button>
</mat-dialog-actions>